import TagManager from 'react-gtm-module'

import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import { ID } from 'src/Types/common'
import { PaymentMethodEnum } from 'src/Constants/enums'

export const reelsConfirmAndPayEvent = ({
  userId,
  campaignId,
  price,
  paymentMethod,
}: {
  userId?: ID | null
  campaignId: number
  price: number
  paymentMethod: PaymentMethodEnum
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'ga_event',

      event_params: {
        event_name: 'reels_confirmed_payment',
        campaign_type: CampaignTypeEnum.FIRST,
        campaign_platform: CampaignPlatformTypeEnum.REELS,
        campaign_id: campaignId,
        userID: userId,
        result_price: price,
        payment_method: paymentMethod,
      },
      user_properties: {
        ...(userId ? { user_id: userId } : {}),
      },
    },
  })
}

export const reelsTikTokTried = ({
  userId,
  campaignId,
  price,
  paymentMethod,
}: {
  userId?: ID | null
  campaignId: number
  price: number
  paymentMethod: PaymentMethodEnum
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'ga_event',

      event_params: {
        event_name: 'reels_tiktok_tried',
        campaign_type: CampaignTypeEnum.FIRST,
        campaign_platform: CampaignPlatformTypeEnum.REELS,
        campaign_id: campaignId,
        userID: userId,
        result_price: price,
        payment_method: paymentMethod,
      },
      user_properties: {
        ...(userId ? { user_id: userId } : {}),
      },
    },
  })
}

export const reelsTikTokNotNow = ({
  userId,
  campaignId,
  price,
  paymentMethod,
}: {
  userId?: ID | null
  campaignId: number
  price: number
  paymentMethod: PaymentMethodEnum
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'ga_event',

      event_params: {
        event_name: 'reels_tiktok_not_now',
        campaign_type: CampaignTypeEnum.FIRST,
        campaign_platform: CampaignPlatformTypeEnum.REELS,
        campaign_id: campaignId,
        userID: userId,
        result_price: price,
        payment_method: paymentMethod,
      },
      user_properties: {
        ...(userId ? { user_id: userId } : {}),
      },
    },
  })
}
